/**
 * Combines multiple query strings into a single GraphQL query with a specified function name.
 *
 * @param queryFunctionName - The name of the GraphQL query function.
 * @param queries - An array of query-generating functions, each returning a GraphQL query string.
 * @returns The complete GraphQL query string.
 *
 * @example
 * const userProfileQuery = getUserProfileDetailGraphQlQuery(['user_id', 'email']);
 * const orderQuery = getOrderDetailsGraphQlQuery(['order_id', 'amount']);
 *
 * const combinedQuery = buildDynamicGraphQLQuery('FetchUserAndOrderData', [
 *   userProfileQuery,
 *   orderQuery,
 * ]);
 *
 * // Result:
 * // query FetchUserAndOrderData {
 * //   user_profile_details {
 * //     success_response { user_id email }
 * //     failure_response { res_status response }
 * //   }
 * //   order_details {
 * //     success_response { order_id amount }
 * //     failure_response { res_status response }
 * //   }
 * // }
 */
export const getNiatApplicationDynamicQuery = (
  queryFunctionName: string,
  queries: string[]
): string => {
  return `
      query ${queryFunctionName} {
        ${queries.join('\n')}
      }
    `;
};
